import React, { useState } from "react";
import "./filter.css"; 

const CustomFilter = ({ 
  options, 
  onFilterChange, 
  multiSelect = false, 
  label = "Filter", 
  placeholder = "Select option(s)" 
}) => {
  const [selectedOptions, setSelectedOptions] = useState(multiSelect ? [] : "");
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (value) => {
    if (multiSelect) {
      const newSelectedOptions = selectedOptions.includes(value)
        ? selectedOptions.filter((item) => item !== value)
        : [...selectedOptions, value];

      setSelectedOptions(newSelectedOptions);
      onFilterChange(newSelectedOptions);
    } else {
      const newValue = selectedOptions === value ? "" : value;
      setSelectedOptions(newValue);
      onFilterChange(newValue);
      setIsOpen(false);
    }
  };

  const clearSelection = (e) => {
    e.stopPropagation(); 
    setSelectedOptions(multiSelect ? [] : "");
    onFilterChange(multiSelect ? [] : "");
  };

  const isSelected = (value) => multiSelect ? selectedOptions.includes(value) : selectedOptions === value;

  return (
    <div className="custom-filter">
      <label className="filter-label">{label}</label>
      <div className="filter-dropdown">
      <div className="filter-selected" onClick={() => setIsOpen(!isOpen)}>
        {multiSelect 
            ? selectedOptions.length > 0 
            ? selectedOptions.join(", ") 
            : placeholder 
            : selectedOptions || placeholder}

        <div className="filter-controls">
            {selectedOptions.length > 0 && (
            <span className="clear-icon" onClick={(e) => { e.stopPropagation(); clearSelection(e); }}>✖</span>
            )}&nbsp;
            <span className="arrow">{isOpen ? "▲" : "▼"}</span>
        </div>
        </div>

        {isOpen && (
          <div className="filter-options">
            {options.map((option) => (
              <div 
                key={option.value} 
                className={`option-item ${isSelected(option.value) ? "selected" : ""}`} 
                onClick={() => handleSelect(option.value)}
              >
                {multiSelect && <input type="checkbox" checked={isSelected(option.value)} readOnly />}
                {option.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomFilter;
